<template>
  <v-btn
    v-if="isVisible"
    depressed
    color="primary"
    class="button-base"
    :loading="isLoading"
    @click="clickHandler"
    >Предоставить дополнительные документы
  </v-btn>
</template>

<script>
import { deleteRejectedFolderAltAddStmt } from '@/api/editedStatement';
import { statusInfoService } from '@/services';
import { RouteName } from '@/router';

export default {
  name: 'AddDocumentsBtn',
  props: {
    statusInfo: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    isVisible() {
      return statusInfoService.canAddDocuments(this.statusInfo);
    },

    hasAddDocumentsRejectedFolderAlt() {
      return statusInfoService.hasAddDocumentsRejectedFolderAlt(
        this.statusInfo.additionalStatements
      );
    },

    addDocumentsDraft() {
      return statusInfoService.getAddDocumentsDraft(
        this.statusInfo.additionalStatements
      );
    },
  },
  methods: {
    async clickHandler() {
      if (this.hasAddDocumentsRejectedFolderAlt) {
        await this.deleteRejectedFolderAltAddStmt();
      }

      this.goToAddDocumentsPage();
    },

    goToAddDocumentsPage() {
      this.$router.push({
        name: RouteName.ADD_DOCUMENTS_APPLICANT,
        params: {
          altStatementId: this.addDocumentsDraft.id,
        },
      });
    },

    async deleteRejectedFolderAltAddStmt() {
      this.isLoading = true;
      await deleteRejectedFolderAltAddStmt(this.statusInfo.statementId);
      this.isLoading = false;
    },
  },
};
</script>
